import React, { Component } from 'react'
import { MarketableMomentModal } from '@driftt/marketable-moment-modal'
import { MODALS } from "../../constants";

import { connect } from 'react-redux'
import { bindActionCreators } from 'redux'

import { patchUserProperties} from "modules/user/actions";
import { getMMModalViewedProperty } from 'modules/user/selectors'

class MMModal extends Component {
  constructor(props) {
    super(props)
    this.state = {
      isOpen: !props.viewedMMModalProperty
    }
  }

  onMMModalClose = () => {
    const { patchUserProperties } = this.props

    this.setState({
      isOpen: false
    })

    patchUserProperties()
  }

  render() {
    const { isOpen } = this.state
    return (
      <MarketableMomentModal onChange={this.onMMModalClose} isOpen={isOpen} modals={MODALS}/>
    )
  }
}

const mapStateToProps = state => ({
  viewedMMModalProperty: getMMModalViewedProperty(state)
})

const mapDispatchToProps = dispatch => (
  bindActionCreators({
    patchUserProperties
  }, dispatch)
)
export default connect(mapStateToProps, mapDispatchToProps)(MMModal)